import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";
import { Link } from "react-router-dom";
gsap.registerPlugin(ScrollTrigger);

const About = ({ callback = (f) => f }) => {
  const wrapper = useRef(null);

  useEffect(() => {
    const q = gsap.utils.selector(wrapper);
    gsap.from(q(".carousel > *"), {
      y: 400,
      rotate: 33,
      stagger: 0.35,
      duration: 0.75,
      // delay: 0.2,
      scrollTrigger: {
        trigger: q(".carousel"),
        toggleActions: "restart resume resume reset",
        start: "center bottom",
        end: "bottom bottom",
      },
    });
    callback();
  });
  const testemonials = [
    {
      title: "Amazing!",
      orderType: "Digital Order",
      author: "Dane Joe",
      body: "Absolutely stunning!",
    },
    {
      title: "Amazing!",
      orderType: "Digital Order",
      author: "Dane Joe",
      body: "Lovely Gifts!",
    },
    {
      title: "Amazing!",
      orderType: "Digital Order",
      author: "Dane Joe",
      body: "Exceptional Lettering.",
    },
  ]; // lg:mt-[180vh]
  return (
    <div ref={wrapper}>
      {" "}
      <section className="testemonials-wrapper z-50 section-padding    w-full overflow-x-hidden mt-8">
        {/* <h1 className="section-heading-alt text-center">Loved</h1>
        <h1 className="section-heading-alt -my-4 text-2xl font-light text-center">
          &
        </h1>
        <h1 className="section-heading-alt text-center">Trusted</h1> */}

        <div
          id="testemonials"
          className=" my-6 snap-x snap-mandatory flex gap-4 flex-row w-max px-8 overflow-x-scroll overflow-y-hidden carousel pb-8 bg-transparent "
        >
          {testemonials.map(({ title, body, author, orderType }, i) => (
            <article
              key={i}
              className="card border border-base-300 rounded-md bg-base-100 shadow-xl snap-always snap-center w-72 sm:w-96 md:w-max md:px-4"
            >
              {/* <figure>
            <img src="https://placeimg.com/400/225/arch" alt="Shoes" />
          </figure> */}
              <div className="card-body">
                <h2 className="card-title flex ">
                  <span className="font-primary font-bold flex-1 md:text-3xl">
                    {title}
                  </span>
                  <div className="badge badge-accent font-light tracking-wide md:text-xl tall-badge">
                    {orderType}
                  </div>
                </h2>
                <p className="font-secondary my-1 text-base-200 font-light text-sm md:text-xl">
                  {author}
                </p>
                <p className="font-secondary font-semibold tracking-wider md:text-2xl">
                  {'"' + body + '"'}
                </p>
              </div>
            </article>
          ))}
        </div>
      </section>
      <div className="flex w-full justify-center">
        <Link to={"/products"}>
          <button className="btn btn-primary btn-wide mb-7 mt-4 md:text-lg md:py-3 md:h-max md:w-max md:px-20">
            Browse Products
          </button>
        </Link>
      </div>
    </div>
  );
};

export default About;
